import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
// import { makeStyles } from '@material-ui/styles';
import styled from 'styled-components';

const DEFAULT_DURATION = 6000;

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

function colorBox (props) {
  switch (props.type) {
    case "success": {
      return `background-color: ${green[600]};`;
    }
    case "error": {
      return `background-color: red;`;
    }
    case "info": {
      return `background-color: #192539;`;
    }
    case "warning": {
      return `background-color: ${amber[700]};`;
    }
  }
}

const SnackbarContent_ = styled(SnackbarContent)`
  && {
    ${colorBox}
  }
`
const Icon_ = Icon => styled(Icon)`
  && {
    font-size: 20;
    opacity: 0.9;
    margin-right: 4px;
  }
`
const Msg = styled.span`
  display: flex;
  align-items: center;
`

function MySnackbarContentWrapper(props) {
  const { message, onClose, variant, ...other } = props;
  const Icon = Icon_(variantIcon[variant]);
  return (
    <SnackbarContent_
      type={variant}
      message={
        <Msg id="client-snackbar">
          <Icon />
          {message}
        </Msg>
      }
      action={[
        <IconButton
          key="close"
          color="inherit"
          onClick={onClose}
        >
          <CloseIcon  />
        </IconButton>,
      ]}
      {...other}
    />
  );
}

MySnackbarContentWrapper.propTypes = {
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

export default function Notication (props) {
  const { notification, setNotification } = props;
  let open = Boolean(notification)
  let notif = notification || {}
  const { message, type, duration } = notif;
  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setNotification(false);
  }

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        autoHideDuration={duration || DEFAULT_DURATION}
        onClose={handleClose}
      >
      {open && 
        <MySnackbarContentWrapper
        onClose={handleClose}
        variant={type}
        message={message}
        />
      }
      </Snackbar>
    </div>
  );
}
